import { Directive, HostListener, Input, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { AlarmAppInstallModalComponent } from '../common/modals/alarm-app-install-modal/alarm-app-install-modal.component'
import { LoginInstallChoiceModalComponent } from '../common/modals/login-install-choice-modal/login-install-choice-modal.component'
import { ModalService } from '../services/modal/modal.service'
import { UserService } from '../services/user/user.service'

@Directive({
  selector: '[appOnlyContent]',
})
export class AppOnlyContentDirective implements OnInit {
  constructor(
    private userService: UserService,
    private translate: TranslateService,
    private modalService: ModalService
  ) {}

  @Input() disable = false

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    if (!this.disable) {
      this.showAppInstallModal()
    }
  }

  ngOnInit(): void {}

  private async showAppInstallModal(): Promise<void> {
    if (this.userService.isLoggedIn) {
      this.translate.get('common.app.installModal').subscribe(async (res) => {
        const { title, desc, button } = res
        const installModal = await this.modalService.openDialog(AlarmAppInstallModalComponent, {
          title,
          description: desc,
          buttonText: button,
        })
        await installModal.present()
      })
      return
    }
    const loginChoiceModal = await this.modalService.openBottomSheet(LoginInstallChoiceModalComponent, {
      logOnClickLogin: () => {},
      logOnClickInstall: () => {},
    })
    await loginChoiceModal.present()
  }
}
